// Array for Project.js
const projects = [
    {
			id: 1,
			link: "https://solo.herokuapp.com/",
			title: "Solo Traveler",
			github: "https://github.com/SSimonPhd/project3",
			image: require("./images/solo-traveler.png"),
    },
		{
			id: 2,
			link: "https://redux-store-simon.herokuapp.com/",
			title: "Redux Store",
			github: "https://github.com/SSimonPhd/redux-store",
			image: require("./images/redux-store.png"),
    },  
		{
			id: 3,
			link: "https://google-book-search-simon.herokuapp.com/",
			title: "Google Book Search",
			github: "https://github.com/SSimonPhd/book-search",
			image: require("./images/book-search.png"),
    },
		{
			id: 4,
			link: "https://boiling-meadow-27323.herokuapp.com/",
			title: "Tech Blog",
			github: "https://github.com/SSimonPhd/tech-blog",
			image: require("./images/tech-blog.png"),
    },
		{
			id: 5,
			link: "https://glacial-tor-40031.herokuapp.com/",
			title: "Note Taker",
			github: "https://github.com/SSimonPhd/note-taker",
			image: require("./images/note-taker.png"),
    },
    {
			id: 6,
			link: "https://ssimonphd.github.io/iservice/",
			title: "iService",
			github: "https://github.com/SSimonPhd/iService",
			image: require("./images/iservice.png"),
    },
		{
			id: 7,
			link: "https://ssimonphd.github.io/day-planner/",
			title: "Day Planner",
			github: "https://github.com/SSimonPhd/day-planner",
			image: require("./images/day-planner.png"),
		},
		{
			id: 8,
			link: "https://ssimonphd.github.io/weather-api/",
			title: "Weather API",
			github: "https://github.com/SSimonPhd/weather-api",
			image: require("./images/weather-api.png"),
		},
    {
			id: 9,
			link: "https://ssimonphd.github.io/codequiz/",
			title: "Code Quiz",
			github: "https://github.com/SSimonPhd/codequiz",
			image: require("./images/codequiz.png"),
    },
    {
			id: 10,
			link: "https://ssimonphd.github.io/password-gen/",
			title: "Password Generator",
			github: "https://github.com/SSimonPhd/password-gen",
			image: require("./images/password-gen.png"),
    },
];

export default projects;